<div class="container-fluid">
  <app-pagetitle id="upper" title="TABLEAU DE BORD" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <!-- ROW CENTRÉE -->
  <div class="row justify-content-center">

    <!-- STATISTIQUES -->
    <ng-container *ngIf="projetData?.length > 0; else noData">

      <!-- Colonne 1 -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title mb-4">Taux d'Exécution Physique (TEP)</h4>

            <div class="row">
              <div class="col-4">
                <h5>Début :</h5>
                <h5>Fin :</h5>
              </div>
              <div class="col-8">
                <h5>{{ date_debut | dateFormat : null }}</h5>
                <h5>{{ date_fin | dateFormat : null }}</h5>
              </div>
            </div>

            <apx-chart dir="ltr" class="apex-charts" [series]="revenueChart?.series"
              [dataLabels]="revenueChart?.dataLabels" [chart]="revenueChart?.chart" [legend]="revenueChart?.legend"
              [colors]="revenueChart?.colors" [labels]="revenueChart?.labels" [stroke]="revenueChart?.stroke"
              [plotOptions]="revenueChart?.plotOptions">
            </apx-chart>
          </div>
        </div>
      </div>

      <!-- Colonne 2 -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title mb-4">Taux d’exécution financière</h4>

            <div class="row">
              <div class="col-4">
                <h5>Début :</h5>
                <h5>Fin :</h5>
              </div>
              <div class="col-8">
                <h5>{{ date_debut | dateFormat : null }}</h5>
                <h5>{{ date_fin | dateFormat : null }}</h5>
              </div>
            </div>

            <apx-chart dir="ltr" class="apex-charts" [series]="revenueChartotal?.series"
              [dataLabels]="revenueChartotal?.dataLabels" [chart]="revenueChartotal?.chart"
              [legend]="revenueChartotal?.legend" [colors]="revenueChartotal?.colors"
              [labels]="revenueChartotal?.labels" [stroke]="revenueChartotal?.stroke"
              [plotOptions]="revenueChartotal?.plotOptions">
            </apx-chart>
          </div>
        </div>
      </div>

      <!-- Colonne 3 -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title mb-4">Taux de décaissement</h4>

            <div class="row">
              <div class="col-4">
                <h5>Début :</h5>
                <h5>Fin :</h5>
              </div>
              <div class="col-8">
                <h5>{{ date_debut | dateFormat : null }}</h5>
                <h5>{{ date_fin | dateFormat : null }}</h5>
              </div>
            </div>

            <apx-chart dir="ltr" class="apex-charts" [series]="revenueChartauxDecaissement?.series"
              [dataLabels]="revenueChartauxDecaissement?.dataLabels" [chart]="revenueChartauxDecaissement?.chart"
              [legend]="revenueChartauxDecaissement?.legend" [colors]="revenueChartauxDecaissement?.colors"
              [labels]="revenueChartauxDecaissement?.labels" [stroke]="revenueChartauxDecaissement?.stroke"
              [plotOptions]="revenueChartauxDecaissement?.plotOptions">
            </apx-chart>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- NO DATA -->
    <ng-template #noData>
      <div class="col-12 col-md-3 d-flex justify-content-center mb-3 ">
        <div class="card d-flex justify-content-center align-items-center text-center" style="height: 350px;">
          <div class="alert alert-warning m-4">
            Aucune donnée disponible.
          </div>
        </div>
      </div>
    </ng-template>

    <!-- COLONNE TÂCHES -->
    <div class="col-12 col-md-3 mb-3">
      <div class="card h-100">
        <div class="card-body">
          <h4 class="card-title mb-4">Tâches</h4>

          <ngx-simplebar style="height: 275px;">
            <ul class="list-unstyled activity-wid">
              <!-- Tâches en retard (Rouge) -->
              <li class="activity-list">
                <div title="Cliquez pour consulter les tâches en retard" style="cursor: pointer;"
                  class="activity-icon avatar-xs">
                  <span (click)="openModalActvite(statsEnretard?.taches_en_retard?.liste, 'bg-danger')"
                    class="avatar-title bg-primary-subtle text-primary rounded-circle">
                    <i class="ri-edit-2-fill"></i>
                  </span>
                </div>
                <div>
                  <div>
                    <h6 id="dash" class="text-danger">
                      Vous avez {{ statsEnretard?.taches_en_retard?.nombres_taches }} tâche(s) en retard
                    </h6>
                  </div>
                </div>
              </li>

              <!-- Tâches urgentes (Orange) -->
              <li class="activity-list">
                <div title="Cliquez pour consulter les tâches urgentes" style="cursor: pointer;"
                  class="activity-icon avatar-xs">
                  <span (click)="openModalActvite(statsEnretard?.taches_urgentes?.liste, 'bg-warning')"
                    class="avatar-title bg-primary-subtle text-primary rounded-circle">
                    <i class="ri-edit-2-fill"></i>
                  </span>
                </div>
                <div>
                  <div>
                    <h5 id="dash" class="text-warning">
                      Vous avez {{ statsEnretard?.taches_urgentes?.nombres_taches }} tâche(s) urgente(s)
                    </h5>
                  </div>
                </div>
              </li>

              <!-- Tâches réalisées (Vert) -->
              <li class="activity-list">
                <div title="Cliquez pour consulter les tâches réalisées" style="cursor: pointer;"
                  class="activity-icon avatar-xs">
                  <span (click)="openModalActvite(statsEnretard?.taches_realisees?.liste, 'bg-success')"
                    class="avatar-title bg-primary-subtle text-primary rounded-circle">
                    <i class="ri-edit-2-fill"></i>
                  </span>
                </div>
                <div>
                  <div>
                    <h5 id="dash" class="text-success">
                      Vous avez {{ statsEnretard?.taches_realisees?.nombres_taches }} tâche(s) réalisée(s)
                    </h5>
                  </div>
                </div>
              </li>
            </ul>

          </ngx-simplebar>
        </div>
      </div>
    </div>

  </div>

  <div class="card p-4 m-4">
    <app-tache></app-tache>

  </div>

</div>


<!-- affichage des taches en ecran modal -->
<ng-template #detailModal let-modal>
  <div class="container-fluid">
    <br>
    <div class="d-flex justify-content-between align-items-center">
      <h4>Tâches ({{items.length}})</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')"> </button>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive mt-3">
          <table class="table table-centered datatable dt-responsive nowrap" style="width: 100%;">
            <thead [ngClass]="headerClass">
              <tr>
                <th>Code</th>
                <th>Libellé</th>
                <th style="white-space: nowrap;">Date de début</th>
                <th>Date de fin</th>
                <th>Poids</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paginatedItems">
                <td>{{item?.code}}</td>
                <td>{{item?.libelle}}</td>
                <td>{{item?.date_debut | dateFormat}}</td>
                <td>{{item?.date_fin | dateFormat}}</td>
                <td>{{item?.poids}}</td>
              </tr>
            </tbody>
          </table>

          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #detailActivite let-modal>
  <div class="container-fluid">
    <br>
    <div class="d-flex justify-content-between align-items-center">
      <h4>Activité ({{activiteItems.length}})</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')"> </button>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive mt-3">
          <table class="table table-centered datatable dt-responsive nowrap" style="width: 100%;">
            <thead [ngClass]="headerClass">
              <tr>
                <th>Code</th>
                <th>Libellé</th>
                <th style="white-space: nowrap;">Date de début</th>
                <th>Date de fin</th>
                <th>Poids</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paginatedItemsActivite">
                <td>{{item?.code_activite}} {{item.code}}</td>
                <td>{{item?.activite}} {{item.libelle}}</td>
                <td>{{item?.date_debut | dateFormat}}</td>
                <td>{{item?.date_fin | dateFormat}}</td>
                <td>{{item?.poids}}</td>
                <td>
                  <a (click)="openModalUpdateCible(item)" href="javascript:void(0);" class="text-primary"
                    v-b-tooltip.hover title="Voir plus">
                    <i class="mdi  mdi-eye-circle font-size-18"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <p-paginator (onPageChange)="onPageChangeActivite($event)" [first]="firstActivite" [rows]="rowsActivite"
            [totalRecords]="totalRecordsActivite" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<p-toast />